module.exports = __webpack_public_path__ + "img/badminton.c0c49ecd.svg";